// @owners { team: patients }

import { COLORS } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, Button, Column, LgPadding } from '@alto/design-system';
import React from 'react';
import {
  RESEND_VERIFICATION_TITLE,
  VERIFICATION_CTA_LOADING_TEXT,
  VERIFICATION_CTA_TEXT,
  VERIFICATION_SINGLE_OPTION_BODY,
  VERIFICATION_TITLE,
} from '~shared/features/onboarding/constants';
import { type Option } from '~shared/features/onboarding/selectors/getOnboardingVerification';
import { getErrorMessage } from '~shared/helpers/helper';
import { type APIError } from '~shared/types';
import { type Values } from '~web/features/onboarding/components/VerificationOptionsActionSheet';

type Props = {
  readonly error?: APIError | Error | null;
  readonly loading?: boolean;
  readonly onSubmit: (values: Values) => void;
  readonly option: Option;
  readonly resend?: boolean;
};

export const VerificationSingleOptionActionSheet = ({ error, loading = false, onSubmit, option, resend }: Props) => {
  const { channel, contact } = option;
  const body = VERIFICATION_SINGLE_OPTION_BODY(channel, contact);
  return (
    <ActionSheetV2
      title={resend ? RESEND_VERIFICATION_TITLE : VERIFICATION_TITLE}
      analyticsName="verification_single_option"
      buttons={[
        <Button
          key="verification-button"
          label={VERIFICATION_CTA_TEXT}
          accessibilityLabel={VERIFICATION_CTA_TEXT}
          loading={loading}
          loadingLabel={VERIFICATION_CTA_LOADING_TEXT}
          onPress={() => {
            onSubmit({ channel });
          }}
        />,
      ]}
    >
      <LgPadding>
        <Column
          gap="SM"
          left
        >
          <Body>{body}</Body>
          {!!error && <Body color={COLORS.PALETTE.DANGER.DEFAULT}>{getErrorMessage(error)}</Body>}
        </Column>
      </LgPadding>
    </ActionSheetV2>
  );
};
